(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[980],{

/***/ 18059:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leit",
      function () {
        return __webpack_require__(70920);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Leit; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var src_components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49012);
/* harmony import */ var src_components_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47347);





var __N_SSG = true;
function Leit() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), query = ref[0], setQuery = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var searchQuery = router.query.q;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (searchQuery !== query) {
            setQuery(searchQuery);
        }
    }, [
        searchQuery,
        query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout__WEBPACK_IMPORTED_MODULE_3__/* .PageContainer */ ._z, {
        title: "Leit | Rekstrarv\xf6rur",
        children: query && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_search__WEBPACK_IMPORTED_MODULE_4__/* .SearchResults */ .s, {
            query: query
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [370,12,774,888,179], function() { return __webpack_exec__(18059); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);